import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21dc11be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "UpdateTemplatesModal__box"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Тип:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Язык:", -1))
const _hoisted_5 = { class: "flex items-center mb-3" }
const _hoisted_6 = ["id", "contenteditable", "onInput", "onKeydown"]
const _hoisted_7 = {
  key: 2,
  class: "UpdateTemplatesModal__box"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-medium mt-2" }, "Прикрепление шаблонов WABA", -1))
const _hoisted_9 = { class: "flex items-center justify-end mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "UpdateTemplatesModal xxl",
    title: "Редактирование шаблонов",
    loading: _ctx.state.is_loading,
    "without-footer": "",
    onCancel: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      (_ctx.state.is_loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_loader, { class: "primary mr-2" }),
            _createTextVNode(" Загрузка... ")
          ]))
        : (_ctx.state.templates.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.templates, (template, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `template-${idx}`
                }, [
                  _createElementVNode("p", null, [
                    _hoisted_3,
                    _createTextVNode(" " + _toDisplayString(template.channel), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_4,
                    _createTextVNode(" " + _toDisplayString(template.lang), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                      id: `editor-${idx}`,
                      contenteditable: template.channel === 'whatsapp' || _ctx.state.is_waba_loading ? 'false' : 'true',
                      class: _normalizeClass(["editable", { 'non-editable': _ctx.state.is_waba_loading || _ctx.state.is_updating || template.channel === 'whatsapp' }]),
                      onInput: (event) => _ctx.updateEditor(idx, event),
                      onKeydown: (event) => _ctx.handleKeydown(idx, event)
                    }, null, 42, _hoisted_6),
                    (template.channel !== 'whatsapp')
                      ? (_openBlock(), _createBlock(_component_the_button, {
                          key: 0,
                          class: "primary small h-fit ml-6",
                          disabled: _ctx.state.is_waba_loading,
                          loading: _ctx.state.is_updating,
                          onClick: ($event: any) => (_ctx.updateNotification(template.id, idx))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Подтвердить ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "loading", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]))
          : (!_ctx.state.templates.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Шаблоны для редактирования не найдены "))
            : _createCommentVNode("", true),
      (_ctx.isCanUpdateWabaTemplates)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _hoisted_8,
            _createVNode(_component_the_select, {
              placeholder: "Выберите шаблоны WABA",
              multiselect: "",
              "open-to-top": "",
              disabled: _ctx.state.is_waba_loading,
              options: _ctx.data_state.templates.list,
              loading: _ctx.data_state.templates.is_loading,
              failed: _ctx.data_state.templates.is_failed,
              value: _ctx.state.waba_templates,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.waba_templates) = $event)),
              onRefresh: _ctx.loadTemplates
            }, {
              option: _withCtx(({ option }) => [
                _createTextVNode(" (ID: " + _toDisplayString(option.id) + ") " + _toDisplayString(option.name), 1)
              ]),
              _: 1
            }, 8, ["disabled", "options", "loading", "failed", "value", "onRefresh"]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_the_button, {
                class: "small primary",
                disabled: _ctx.state.is_waba_loading,
                loading: _ctx.state.is_waba_loading,
                onClick: _ctx.updateWabaTemplates
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Прикрепить")
                ]),
                _: 1
              }, 8, ["disabled", "loading", "onClick"])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "onCancel"]))
}